var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 19.251h.5c0-5.206 1.822-8.449 3.88-10.467 2.072-2.03 4.42-2.854 5.5-3.144l.37-.1V2.75a.248.248 0 0 1 .415-.186l.002.001 6.75 6a.249.249 0 0 1 0 .373l-6.75 6h-.001a.25.25 0 0 1-.417-.186V11.992l-.569.08c-1.845.256-6.383 1.483-8.698 7.27l.463.186-.463-.186a.25.25 0 0 1-.482-.093l-.5.001Zm0 0c0-10.676 7.497-13.49 9.75-14.094L4 19.251Z",
    fill: "currentColor",
    stroke: "currentColor"
  })));
};
export default SvgShare;